import ThemeManager from '@js/themeManager'

let _themeManager
(function(){
    _themeManager = new ThemeManager()
    window.cgsDesignThemeManager = _themeManager
    _themeManager.addTheme()
})()

export default _themeManager
